"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _product = require("@/api/product");
var _ZBKJIutil = require("@/utils/ZBKJIutil");
var _product2 = _interopRequireDefault(require("@/mixins/product"));
var _default3 = require("@/views/marketing/pointsMall/default");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
var _default2 = exports.default = {
  name: 'ProductProductAdd',
  props: {
    isShow: {
      type: Boolean,
      default: true
    },
    isAtud: {
      type: Boolean,
      default: false
    },
    productId: {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    componentKey: {
      type: Number,
      default: function _default() {
        return 0;
      }
    },
    dialogVisibleInfoData: {
      type: Boolean,
      default: false
    },
    fromType: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },
  components: {
    Tinymce: _index.default
  },
  mixins: [_product2.default],
  watch: {
    'formValidate.attrList': {
      handler: function handler(val) {
        //  if (this.formValidate.specType) this.watCh(val); //重要！！！
      },
      immediate: false,
      deep: true
    },
    componentKey: {
      handler: function handler(val) {
        this.currentTab = '0';
        this.dialogVisible = true;
      },
      immediate: false,
      deep: true
    },
    dialogVisibleInfoData: {
      handler: function handler(val) {
        var _this = this;
        this.loading = true;
        this.AttrValueList = [];
        if (val) {
          if (this.fromType === 'product') {
            //普通商品详情
            this.getProductInfo(this.productId);
            setTimeout(function () {
              _this.getTableAttrValue();
            }, 500);
          } else {
            //积分商品详情
            this.getPointsProductInfo(this.productId);
          }
        }
        this.loading = false;
      },
      immediate: false,
      deep: true
    }
  },
  data: function data() {
    return {
      manyTabTit: {},
      manyTabDate: {},
      // 生成规格表格中的头部标题
      formThead: Object.assign({}, _default3.objTitle),
      OneattrValue: [Object.assign({}, _default3.defaultObj.attrValueList[0])],
      // 单规格
      ManyAttrValue: [Object.assign({}, _default3.defaultObj.attrValueList[0])],
      // 多规格
      tableAttrValue: {},
      //商品规格
      rules: {
        auditStatus: [{
          required: true,
          message: '请选择审核状态',
          trigger: 'change'
        }],
        reason: [{
          required: true,
          message: '请填写拒绝原因',
          trigger: 'blur'
        }]
      },
      ruleForm: {
        reason: '',
        auditStatus: 'success',
        id: ''
      },
      direction: 'rtl',
      dialogVisible: false,
      isDisabled: true,
      props1: {
        children: 'childList',
        label: 'name',
        value: 'id',
        multiple: false,
        emitPath: false
      },
      tabs: [],
      props: {
        multiple: true
      },
      currentTab: '0',
      isAttr: false,
      loadingBtn: false,
      frontDomain: localStorage.getItem('frontDomain')
    };
  },
  created: function created() {
    this.tempRoute = Object.assign({}, this.$route);
    this.currentTab = '0';
    if (this.$route.params.id && this.formValidate.specType) {
      //    this.$watch(this.formValidate.attrList, this.watCh);
    }
    if (!localStorage.getItem('merPlatProductClassify')) this.$store.dispatch('product/getAdminProductClassify');
  },
  mounted: function mounted() {
    this.getTableAttrValue();
    if (this.productId) {
      this.currentTab = '0';
      this.setTagsViewTitle();
    }
  },
  methods: {
    getListName: _ZBKJIutil.getListName,
    getFrontDomainUrl: _ZBKJIutil.getFrontDomainUrl,
    //表格内的数据
    getTableAttrValue: function getTableAttrValue() {
      var obj = Object.assign({}, _default3.defaultObj.attrValueList[0]);
      delete obj.image;
      delete obj.isShow;
      //普通商品去掉兑换积分
      if (this.fromType === 'product') {
        delete obj.redeemIntegral;
      } else {
        // 积分金额去掉otPrice
        delete obj.otPrice;
      }
      if (!this.formValidate.isSub) {
        delete obj.brokerage;
        delete obj.brokerageTwo;
      }
      if (!this.formValidate.isPaidMember) {
        delete obj.vipPrice;
      } else {
        obj.vipPrice = Object.assign({}, _default3.defaultObj.attrValueList[0]).vipPrice;
      }
      this.tableAttrValue = obj;
    },
    close: function close() {
      this.dialogVisible = false;
      this.currentTab = '0';
    },
    //审核拒绝
    cancelForm: function cancelForm() {
      var _this2 = this;
      this.$modalPrompt('textarea', '拒绝原因').then(function (V) {
        _this2.ruleForm.reason = V;
        _this2.submit();
      });
    },
    // 审核提交
    onSubmit: function onSubmit(type) {
      var _this3 = this;
      this.ruleForm.auditStatus = type;
      if (type === 'success') {
        this.$modalSure('审核通过该商品吗？').then(function () {
          _this3.submit();
        });
      } else {
        this.cancelForm();
      }
    },
    submit: function submit() {
      var _this4 = this;
      this.loadingBtn = true;
      this.ruleForm.id = this.productId;
      (0, _product.productAuditApi)(this.ruleForm).then(function (res) {
        _this4.$message.success('操作成功');
        //this.dialogVisible = false;
        _this4.currentTab = '0';
        _this4.$emit('subSuccess');
        _this4.loadingBtn = false;
      }).catch(function (res) {
        _this4.loadingBtn = false;
      });
    },
    changeNodes: function changeNodes(data) {
      if (data.length > 0) {
        for (var i = 0; i < data.length; i++) {
          if (!data[i].childList || data[i].childList.length < 1) {
            data[i].childList = undefined;
          } else {
            this.changeNodes(data[i].childList);
          }
        }
      }
      return data;
    },
    setTagsViewTitle: function setTagsViewTitle() {
      var title = this.isDisabled ? '商品详情' : '编辑商品';
      var route = Object.assign({}, this.tempRoute, {
        title: "".concat(title, "-").concat(this.$route.params.id)
      });
      this.$store.dispatch('tagsView/updateVisitedView', route);
    },
    // 表单验证
    validate: function validate(prop, status, error) {
      if (status === false) {
        this.$message.warning(error);
      }
    },
    onClose: function onClose() {
      this.ruleForm.auditStatus = 'success';
      this.ruleForm.reason = '';
      this.$emit('onCloseInfo');
    }
  }
};